var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutController',[_c('Icon'),_c('AnalyticsIcon'),_c('RouterView',{staticClass:"Simple"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }